__turbopack_context__.v({
  "MagazineTrendCards": "_7bY-AW_MagazineTrendCards",
  "hiddenMobile": "_7bY-AW_hiddenMobile",
  "loadMoreButton": "_7bY-AW_loadMoreButton",
});
